import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';
import Toggle from '../Toggle';
import TooltipWrapper from '../TooltipWrapper';
import { PauseIcon, PlayIcon } from '../../icons';
import styles from './styles.module.scss';

export type AutoplayToggleProps = {
  active: boolean;
  onToggle: () => void;
  className?: string;
  containerClassName?: string;
};

const AutoplayToggle = ({ active, onToggle, className, containerClassName }: AutoplayToggleProps) => {
  const { t } = useTranslation('common');
  const tooltipText = active ? t('tooltips.autoplay.active') : t('tooltips.autoplay.inactive');
  const ariaLabel = active ? t('aria_labels.controls.autoplay.active') : t('aria_labels.controls.autoplay.inactive');

  return (
    <TooltipWrapper className={containerClassName} tooltipText={tooltipText} tooltipPosition='top'>
      <button className={styles.containerToggle} type='button' onClick={onToggle}>
        <Toggle
          className={classNames(className, { [styles.active]: active })}
          checked={active}
          data-testid='autoplay-toggle'
          aria-label={ariaLabel}
          icon={
            active ? (
              <PlayIcon data-testid='autoplay-play-icon' width={6} height={8} />
            ) : (
              <PauseIcon data-testid='autoplay-pause-icon' width={6} height={8} />
            )
          }
        />
      </button>
    </TooltipWrapper>
  );
};

export default AutoplayToggle;
